import { render, staticRenderFns } from "./RootsAndDegrees.vue?vue&type=template&id=6e11caee&scoped=true&lang=pug&"
import script from "./RootsAndDegrees.vue?vue&type=script&lang=js&"
export * from "./RootsAndDegrees.vue?vue&type=script&lang=js&"
import style0 from "./RootsAndDegrees.vue?vue&type=style&index=0&id=6e11caee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e11caee",
  null
  
)

export default component.exports